import {
  downloadExportedFiscalCapitalBalance,
  getFiscalCapitalBalanceList,
  getAccountingCapitalBalanceList,
  downloadExportedAccountingCapitalBalance,
  getFiscalCapitalBalanceSummary,
  getAccountingCapitalBalanceSummary
} from 'src/services/capitalBalanceService';
import { SnackBarVariants } from 'src/utils/constants/common';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import getOptionsFromState from 'src/utils/balanceUtils';
import {
  selectFiscalCapitalBalanceQueryOptions,
  selectAccountingCapitalBalanceQueryOptions
} from '../selectors/capitalBalanceSelectors';
import { showMessage } from './snackBarActions';
// FISCAL
export const LOAD_FISCAL_CAPITAL_BALANCE = asyncActionCreator(
  'LOAD_FISCAL_CAPITAL_BALANCE'
);
export const DOWNLOAD_FISCAL_CAPITAL_BALANCE = asyncActionCreator(
  'DOWNLOAD_FISCAL_CAPITAL_BALANCE'
);
export const CLEAR_FISCAL_CAPITAL_BALANCE = 'CLEAR_FISCAL_CAPITAL_BALANCE';
export const SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS =
  'SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS';
export const CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS =
  'CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS';

// ACCOUNTING
export const LOAD_ACCOUNTING_CAPITAL_BALANCE = asyncActionCreator(
  'LOAD_ACCOUNTING_CAPITAL_BALANCE'
);
export const DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE = asyncActionCreator(
  'DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE'
);
export const CLEAR_ACCOUNTING_CAPITAL_BALANCE =
  'CLEAR_ACCOUNTING_CAPITAL_BALANCE';
export const SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS =
  'SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS';
export const CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS =
  'CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS';

export const LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY = asyncActionCreator(
  'LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY'
);
export const LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY = asyncActionCreator(
  'LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY'
);

// FISCAL ACTIONS
export const clearFiscalCapitalBalanceOptions = () => dispatch => {
  dispatch({ type: CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS });
};

export const clearFiscalCapitalBalance = () => dispatch => {
  dispatch({ type: CLEAR_FISCAL_CAPITAL_BALANCE });
};

export const loadFiscalCapitalBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE.start });
    dispatch({
      type: SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectFiscalCapitalBalanceQueryOptions,
      getState
    );

    const fiscalCapitalBalance = await getFiscalCapitalBalanceList(reqOptions);

    return dispatch({
      type: LOAD_FISCAL_CAPITAL_BALANCE.success,
      ...fiscalCapitalBalance
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE.failure });
  }
};

export const downloadExcelFiscalCapitalBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: DOWNLOAD_FISCAL_CAPITAL_BALANCE.start
    });

    dispatch({
      type: SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectFiscalCapitalBalanceQueryOptions,
      getState
    );
    await downloadExportedFiscalCapitalBalance(reqOptions);

    return dispatch({
      type: DOWNLOAD_FISCAL_CAPITAL_BALANCE.success
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: DOWNLOAD_FISCAL_CAPITAL_BALANCE.failure });
  }
};

// ACCOUNTING ACTIONS
export const clearAccountingCapitalBalanceOptions = () => dispatch => {
  dispatch({ type: CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS });
};

export const clearAccountingCapitalBalance = () => dispatch => {
  dispatch({ type: CLEAR_ACCOUNTING_CAPITAL_BALANCE });
};

export const loadAccountingCapitalBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_ACCOUNTING_CAPITAL_BALANCE.start });

    dispatch({
      type: SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
      options
    });
    const reqOptions = getOptionsFromState(
      selectAccountingCapitalBalanceQueryOptions,
      getState
    );

    const accountingCapitalBalance = await getAccountingCapitalBalanceList(
      reqOptions
    );

    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE.success,
      ...accountingCapitalBalance
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE.failure,
      error: error.message
    });
  }
};

export const downloadExcelAccountingCapitalBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE.start
    });

    dispatch({
      type: SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptionsFromState(
      selectAccountingCapitalBalanceQueryOptions,
      getState
    );
    await downloadExportedAccountingCapitalBalance(reqOptions);

    return dispatch({
      type: DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE.success
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: 'error' }));
    return dispatch({ type: DOWNLOAD_ACCOUNTING_CAPITAL_BALANCE.failure });
  }
};

// SUMMARY ACTIONS
export const loadFiscalCapitalBalanceSummary = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY.start });

    dispatch({
      type: SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS,
      options
    });
    const reqOptions = getOptionsFromState(
      selectFiscalCapitalBalanceQueryOptions,
      getState
    );

    const summary = await getFiscalCapitalBalanceSummary(reqOptions);

    return dispatch({
      type: LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY.success,
      ...summary
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: SnackBarVariants.ERROR }));
    return dispatch({ type: LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY.failure });
  }
};

export const loadAccountingCapitalBalanceSummary = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY.start });

    dispatch({
      type: SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
      options
    });
    const reqOptions = getOptionsFromState(
      selectAccountingCapitalBalanceQueryOptions,
      getState
    );

    const summary = await getAccountingCapitalBalanceSummary(reqOptions);

    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY.success,
      ...summary
    });
  } catch (error) {
    dispatch(showMessage({ message: error.message, variant: SnackBarVariants.ERROR }));
    return dispatch({
      type: LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY.failure
    });
  }
};
